import { render } from "./SearchBarSuggestions.vue?vue&type=template&id=44ed773e"
import script from "./SearchBarSuggestions.vue?vue&type=script&lang=js"
export * from "./SearchBarSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\1\\s\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__